import * as client from "_graphql-types";
import * as types from "./types";

type Sdk = ReturnType<typeof client.getSdk>;

/*********************************************************************/
// Data Provider Functions
/*********************************************************************/

/*********************************************************************/
async function getList(
  sdk: Sdk,
  params: types.GetListParams<client.FdpLoginAuthenticatorEnumSortEnum>
) {
  const {
    pagination: { page, perPage },
    sort: { field, order },
  } = params;

  const {
    fdpLoginAuthenticatorEnumList: { items: data, total },
  } = await sdk.getListFdpLoginAuthenticatorEnum({
    page: {
      offset: (page - 1) * perPage,
      limit: perPage,
    },
    sort: [{ field, order }],
  });

  return {
    data,
    total,
  };
}

/*********************************************************************/
async function getOne(sdk: Sdk, params: types.GetOneParams) {
  const id = Number(params.id);
  const { fdpLoginAuthenticatorEnum: data } =
    await sdk.getOneFdpLoginAuthenticatorEnum({
      id,
    });
  return {
    data,
  };
}

/*********************************************************************/
async function getMany(sdk: Sdk, params: types.GetManyParams) {
  const ids = params.ids.map(id => Number(id));

  const { fdpLoginAuthenticatorEnumMany: data } =
    await sdk.getManyFdpLoginAuthenticatorEnum({
      ids,
    });

  return {
    data,
  };
}

/*********************************************************************/
export const fdpLoginAuthenticatorEnum = types.dataProvider({
  getList,
  getOne,
  getMany,
  ttl: types.defaultEnumTtl,
});
